export default {"src":"/_next/static/media/telegram.96bbd897.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};